import { useState } from "react";


export const PartnersSection=()=>{
    
    const slierArr=[
        {
            title:'1214523 2345 242 3252',
            partnerName:'Grzegosz Bzhenzhyshchekevych',
            position:'iron',
            companyName:'paragon'
        },
        {
            title:'Ipsum aute sunt aliquip aute et occaecat. Anim minim do cillum eiusmod enim. Consectetur magna cillum consequat minim laboris cillum laboris voluptate minim proident exercitation ullamco.',
            partnerName:'Shawn Edwards',
            position:'Position',
            companyName:'Company Name'
        }
    ]
    const [activeScrollVal,setActiveScrollVal]=useState(1)
    const sliderhandler=(actionType:string)=>{
        switch(actionType){
            case 'scrollForward':
                if(slierArr.length==activeScrollVal){
                    setActiveScrollVal(1)    
                }else{
                    setActiveScrollVal(activeScrollVal+1)
                }
                break;
            case 'scrollBack':
                if(1==activeScrollVal){
                    setActiveScrollVal(slierArr.length)    
                }else{
                    setActiveScrollVal(activeScrollVal-1)
                }
                break;    
        }
        
    }

    return(
        <div className="partners-section_bg">
            <div className="partners-section __container">
                <div className="partners-section_header">
                    <h1>Supported by 12+ partners</h1>
                </div>
                <div className="partners-section_partners-placeholder">
                    {[1,2,3,4,5,6].map(p=>
                        <div key={p}>
                            <img src={require('../../../static/InDepth_Consulting_Logo-Untitled_Page.png')}/>
                        </div>
                    )}
                    
                </div>
                <div className="partners-section_body">
                    <div className="partners-section_body-slider">
                        <h1>What our clients are saying</h1>
                        <div className="partners-section_body-slider_carousel">
                            <div className="partners-section_body-slider_carousel_avatar -ibg">
                                <img src={require('../../../static/profile-image-partners-section.png')}/>
                            </div>
                            <div className="partners-section_body-slider_carousel_text">
                                <p>{slierArr[activeScrollVal-1].title}</p>
                            </div>
                            <div className="partners-section_body-slider_carousel_nav">
                                <div>
                                    <strong>{slierArr[activeScrollVal-1].partnerName}</strong>
                                    <p>{slierArr[activeScrollVal-1].position}, {slierArr[activeScrollVal-1].companyName}</p>
                                </div>
                                <div>
                                    <svg onClick={()=>sliderhandler('scrollBack')} width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle opacity="1" cx="24" cy="24" r="24" fill="#F4F5F6"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.2071 29.2071C20.8166 29.5976 20.1834 29.5976 19.7929 29.2071L15.2929 24.7071C14.9024 24.3166 14.9024 23.6834 15.2929 23.2929L19.7929 18.7929C20.1834 18.4024 20.8166 18.4024 21.2071 18.7929C21.5976 19.1834 21.5976 19.8166 21.2071 20.2071L18.4142 23H32C32.5523 23 33 23.4477 33 24C33 24.5523 32.5523 25 32 25H18.4142L21.2071 27.7929C21.5976 28.1834 21.5976 28.8166 21.2071 29.2071Z" fill="black"/>
                                    </svg>
                                    <svg onClick={()=>sliderhandler('scrollForward')}  width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle opacity="1" cx="24" cy="24" r="24" fill="#F4F5F6"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.7929 18.7929C27.1834 18.4024 27.8166 18.4024 28.2071 18.7929L32.7071 23.2929C33.0976 23.6834 33.0976 24.3166 32.7071 24.7071L28.2071 29.2071C27.8166 29.5976 27.1834 29.5976 26.7929 29.2071C26.4024 28.8166 26.4024 28.1834 26.7929 27.7929L29.5858 25H16C15.4477 25 15 24.5523 15 24C15 23.4477 15.4477 23 16 23H29.5858L26.7929 20.2071C26.4024 19.8166 26.4024 19.1834 26.7929 18.7929Z" fill="black"/>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="partners-section_body-image -ibg">
                        <img src={require('../../../static/image-partners-seciton.jpg')}/>
                    </div>
                </div>
            </div>
        </div>
        
    )
}